import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the LocationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LocationProvider {
  constructor(public http: HttpClient) {}

  getLocation(): Observable<any> {
    return this.http.get('https://ipinfo.io?token=49cbe3409a1f6a');
  }
}



// WEBPACK FOOTER //
// ./src/providers/location/location.ts